import { useEffect, useRef } from "react";
import { io, type Socket } from "socket.io-client";
import { API_BASE } from "@/lib/api";

let sharedSocket: Socket | null = null;

function getSocket(): Socket {
  if (!sharedSocket) {
    const opts = {
      autoConnect: true,
      withCredentials: true,
      transports: ["websocket", "polling"] as string[],
    };
    sharedSocket = API_BASE ? io(API_BASE, opts) : io(opts);
  }
  return sharedSocket;
}

export function useSocket(): Socket {
  const ref = useRef<Socket | null>(null);
  if (!ref.current) {
    ref.current = getSocket();
  }
  return ref.current;
}

export function useRoomSocket(code: string | undefined): Socket {
  const socket = useSocket();
  useEffect(() => {
    if (!code) return;
    const upper = code.toUpperCase();
    socket.emit("room:join", upper);
    return () => {
      socket.emit("room:leave", upper);
    };
  }, [code, socket]);
  return socket;
}
